module.exports = __webpack_public_path__ + "static/index/img/baikal-700.0f213f1e.jpg";